import { apiClient } from '@/lib/apiClient';
import type { CustomTheme } from '@/theme';

const BASE_PATH = '/api/tenant-theme';

/** The tenant's own colours. Every user reads them; writing takes `Core.Theme.Manage`. */
export const tenantThemeService = {
  /** Null when the tenant has no colours of its own (the API answers 204). */
  async get(): Promise<CustomTheme | null> {
    const { data, status } = await apiClient.get<CustomTheme>(BASE_PATH);
    return status === 204 ? null : data;
  },

  async update(theme: CustomTheme): Promise<CustomTheme> {
    const { data } = await apiClient.put<CustomTheme>(BASE_PATH, theme);
    return data;
  },
};
